import { useMutation, useQueryClient } from "@tanstack/react-query"
import { rejectRfqBuyerToAdmin, type RejectRfqBuyerToAdminPayload } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export interface RejectRfqBuyerToAdminVariables {
  id: string
  payload: RejectRfqBuyerToAdminPayload
}

export function useRejectRfqBuyerToAdmin() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, payload }: RejectRfqBuyerToAdminVariables) =>
      rejectRfqBuyerToAdmin(id, payload, accessToken!),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["admin-rfqs"] })
      queryClient.invalidateQueries({ queryKey: ["buyer-rfq-detail", id] })
      queryClient.invalidateQueries({ queryKey: ["buyer-to-admin-rfq-detail", id] })
      queryClient.invalidateQueries({ queryKey: ["buyer-rfq-status-updates", id] })
      queryClient.invalidateQueries({ queryKey: ["buyer-rfqs"] })
    },
  })
}

